import { Input } from 'antd';
import type { InputProps } from 'antd/es/input';

import { ClearIcon } from '@/shared/assets/icons/input/ClearIcon';
import { ReactComponent as SearchIcon } from '@/shared/assets/icons/input/search.svg';
import { COLOR } from '@/shared/design-tokens/design-tokens';
import { VALIDATION_RULES } from '@/shared/lib/constants';

import styles from './SearchInput.module.css';

const CLEAR_ICON_SIZE = 14;
const DEFAULT_CLEAR_ICON_BG = COLOR.GRAY[80];
const DEFAULT_CLEAR_ICON_COLOR = COLOR.GRAY[100];

type SearchInputProps = Omit<InputProps, 'prefix' | 'allowClear'> & {
  prefix?: React.ReactNode;
  allowClear?: boolean | { clearIcon?: React.ReactNode };
};

const defaultPrefix = <SearchIcon className={styles.searchIcon} width={13} height={13} fill={COLOR.GRAY[10]} />;

const SearchInput: React.FC<SearchInputProps> = ({
  prefix = defaultPrefix,
  className,
  allowClear = true,
  'aria-label': ariaLabel,
  maxLength = VALIDATION_RULES.SEARCH_MAX_LENGTH,
  ...restProps
}) => {
  const mergedClassName = (() => {
    return className ? `${styles.searchInput} ${className}` : styles.searchInput;
  })();

  const allowClearConfig = (() => {
    if (allowClear === false) return false;
    if (typeof allowClear === 'object' && allowClear.clearIcon) {
      return allowClear;
    }
    return {
      clearIcon: (
        <ClearIcon
          size={CLEAR_ICON_SIZE}
          backgroundColor={DEFAULT_CLEAR_ICON_BG}
          iconColor={DEFAULT_CLEAR_ICON_COLOR}
        />
      ),
    };
  })();

  return (
    <Input
      className={mergedClassName}
      prefix={prefix ?? defaultPrefix}
      allowClear={allowClearConfig}
      aria-label={ariaLabel ?? '검색'}
      maxLength={maxLength}
      {...restProps}
    />
  );
};

export { SearchInput };
export type { SearchInputProps };
